import ValueObject from './ValueObject';

export default class SubSegmentId extends ValueObject {
  equals(other) {
    if (!(other instanceof SubSegmentId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new SubSegmentId(json);
  }
}
